import { topicRepository } from "../../../providers/repositories/topicRepository";
import { Topic, TopicFormData } from "../entities/Topic";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const addUpdateTopicUseCase = {
    async exec(
        data: TopicFormData,
        id: number | string | null,
    ): Promise<Topic | null> {
        try {
            const topic = await topicRepository.addUpdate(data, id);

            if (id) {
                toast.success(t("action.updateSuccess"));
            }
            return topic;
        } catch (error) {
            toast.error(t("action.updateError"));
            Logger.error("updateTopicUseCase", error);
        }

        return null;
    },
};
